const FINANCE_TYPE = "finance_type";
const LOCKED_FINANCE_TYPES = ["leasing", "rent"];
/**
 * Make pages (/marka/{make} = leasing, /wynajem-dlugoterminowy/marka/{make} = rent) fix the
 * finance type by URL. PHP renders it as data-locked-finance-type on the mount node.
 */
export function parseLockedFinanceType(value) {
    var _a;
    return (_a = LOCKED_FINANCE_TYPES.find((type) => type === value)) !== null && _a !== void 0 ? _a : null;
}
/** Forces the locked finance type into the selection, so facets and submit URLs keep the page's intent. */
export function withLockedFinanceType(selected, locked) {
    return locked ? Object.assign(Object.assign({}, selected), { [FINANCE_TYPE]: locked }) : selected;
}
/** Hides the finance type switch when the page locks it. */
export function withoutLockedPathFilters(pathFilters, locked) {
    return locked ? pathFilters.filter((filter) => filter.id !== FINANCE_TYPE) : pathFilters;
}
